import React from "react";
import "./Home.css";
import Typical from "react-typical";
import { Link } from "react-scroll";
import Fade from "react-reveal/Fade";
import Rotate from "react-reveal/Rotate";
const Home = () => {
  return (
    <div className="home d-flex align-items-center">
      <div className="home-container">
        <div className="text-1">
          <Fade left>Hello, my name is</Fade>
        </div>
        <div className="text-2">
          <Rotate top left>
            Hadid Billa
          </Rotate>
        </div>
        <div className="text-3 d-inline">
          I am a
          <span>
            <Typical
              className="d-inline"
              steps={[" Developer", 4000, " Programmer", 5000]}
              loop={Infinity}
              wrapper="h3"
            />
          </span>
        </div>
      </div>
    </div>
  );
};

export default Home;
